import React, { useEffect, useState } from "react";
import {
  useQuery,
  useSelectedTheme,
  useTranslate,
} from "../../../../../../../../Hooks";
import {
  CustomButton,
  CustomCard,
  CustomDialog,
  DropzoneComponent,
} from "../../../../../../../../Components";
import { Box, Divider, Typography } from "@material-ui/core";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { PropertyImagesType } from "../../../../../../../../Enums";
import { UpdatePropertyImage } from "../../../../../../../../Services";

// styles
import useStyles from "./styles";

// icons
import {
  DeleteIcon,
  Download01,
  Image01Icon,
} from "../../../../../../../../assets/icons";

function EditPropertyImageDialog({
  open,
  onClose,
  data,
  activeImage,
  setRefetchDataPropertyImage,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const query = useQuery();
  const { setAlertBoxContent } = useVerticalNav();
  const session = JSON.parse(localStorage.getItem("session"));
  const [filesAccepted, setFilesAccepted] = useState([]);
  const [uploadedFileId, setUploadedFileId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [initalizeTotalImage, setInitalizeTotalImage] = useState(0);
  const [selectedImage, setSelectedImage] = useState(0);
  const userId = session ? session.userId : "";

  const handleFilesAccepted = (files) => {
    setFilesAccepted(files);
  };

  const handleSave = async () => {
    try {
      const mappedFiles = uploadedFiles.map((file) => ({
        fileId: file.fileId,
        fileName: file.fileName,
      }));

      const state = {
        categoryId: data?.categoryId ?? null,
        propertyId: Number(query.get("id")),
        imageType: PropertyImagesType.Image,
        files: mappedFiles,
      };

      const res = await UpdatePropertyImage(state);
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: translate("UpdatePropertyImage-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        setRefetchDataPropertyImage(true);
        onClose();
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: translate("Update-PropertyImage-failed"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("some-Thing-Wrong"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
    }
  };

  const handleDeleteUploadedFile = (index) => {
    setUploadedFiles((prevUploadedFiles) =>
      prevUploadedFiles.filter((_, i) => i !== index)
    );
    setInitalizeTotalImage(initalizeTotalImage - 1);
  };

  const handleFileUploadMapping = () => {
    if (uploadedFileId) {
      setUploadedFiles((prevUploadedFiles) => [
        ...prevUploadedFiles,
        filesAccepted[0],
      ]);
      setUploadedFiles((prevUploadedFiles) => {
        const updatedFiles = [...prevUploadedFiles];
        if (updatedFiles?.length > 0) {
          updatedFiles[updatedFiles.length - 1] = {
            ...updatedFiles[updatedFiles.length - 1],
            categoryId: data.categoryId,
            createdBy: userId,
            fileId: uploadedFileId,
            fileName: updatedFiles[updatedFiles?.length - 1]?.path,
            propertyId: Number(query.get("id")),
          };
        }
        return updatedFiles;
      });
      setInitalizeTotalImage(initalizeTotalImage + 1);
    }
  };

  const downloadDocument = (item) => {
    if (!item) {
      return;
    }
    try {
      const link = document.createElement("a");
      link.setAttribute("download", item.fileName);
      link.href = getDownloadableLink(item.fileId);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  useEffect(() => {
    const files = Array.isArray(data?.images?.result) ? data.images.result : [];
    const initialActive = activeImage || files[0];
    const reordered = initialActive
      ? [
          initialActive,
          ...files.filter((img) => img.fileId !== initialActive.fileId),
        ]
      : files;
    setUploadedFiles(reordered);
    setInitalizeTotalImage(files.length);
    setSelectedImage(initialActive);
  }, [data]);

  useEffect(() => {
    handleFileUploadMapping();
  }, [uploadedFileId]);

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={translate("Edit-images-group")}
      subtitle={translate(
        "Create-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
      )}
      cancelText={translate("Cancel")}
      confirmText={translate("Save-changes")}
      onConfirm={handleSave}
      width={"699px"}
      content={
        <Box className={styles.wrapperEditDialog}>
          <Typography className={styles.titleItem}>
            {translate("Images")}
          </Typography>
          <Box className={styles.containerUploadSection}>
            <DropzoneComponent
              accept="image/*"
              title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
              onFilesAccepted={handleFilesAccepted}
              setUploadedFileId={setUploadedFileId}
            />
            <Box className={styles.secctionImage}>
              <Box className={styles.containerImageTitle}>
                <Typography className={styles.ImageTitle}>
                  {`${initalizeTotalImage} images`}
                </Typography>
                <Divider style={{ flexGrow: 1, alignSelf: "center" }} />
              </Box>
              <Box className={styles.containerUploadedFiles}>
                {uploadedFiles.map((file, index) => (
                  <CustomCard
                    key={file.fileId || index}
                    boxShadow="xs"
                    borderRadius="xl"
                    borderColor="secondary"
                    classes={styles.cardUploadedFilesInfo}
                    onClick={() => setSelectedImage(file)}
                    style={{
                      border:
                        selectedImage?.fileId === file.fileId
                          ? `2px solid ${palette.button.primary_bg}`
                          : "2px solid transparent",
                      cursor: "pointer",
                    }}
                  >
                    <Box className={styles.containerImage}>
                      <img
                        src={getDownloadableLink(file.fileId)}
                        alt={file.fileName}
                        className={styles.wrapperImage}
                      />
                    </Box>

                    <Box
                      onClick={() => handleDeleteUploadedFile(index)}
                      className={styles.containerDeleteIcon}
                    >
                      <DeleteIcon
                        width="20"
                        height="20"
                        fill={palette.foreground.secondary_fg}
                      />
                    </Box>

                    <Box className={styles.containerPlaceHolderImage}>
                      <Image01Icon
                        width="56"
                        height="56"
                        fill={palette.foreground.senary}
                      />
                    </Box>
                  </CustomCard>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      }
      moreAction={
        <CustomButton
          boxShadow="none"
          size="lg"
          variant="text"
          color="tertiaryGray"
          startIcon={
            <Download01
              width="20"
              height="20"
              fill={palette.button.tertiaryGray_fg}
            />
          }
          onClick={() => {
            downloadDocument(selectedImage);
          }}
          style={{ marginInlineEnd: "auto" }}
        >
          {translate("Download")}
        </CustomButton>
      }
    />
  );
}

export default EditPropertyImageDialog;
